export interface SuperTableStructuredData {
    columnLength: number;
    rows: {
        rowType: string;
        col0?: number | string | undefined;
        col1?: number | string | undefined;
        col2?: number | string | undefined;
        col3?: number | string | undefined;
        col4?: number | string | undefined;
        col5?: number | string | undefined;
        col6?: number | string | undefined;
        col7?: number | string | undefined;
        col8?: number | string | undefined;
    }[];
}
